import * as yup from 'yup';

export const updateRoomVideoValidations = yup.object().shape({
  videoURL: yup
    .string()
    .transform((value: string | null) => (value === '' ? null : value)) // Transform empty string to null
    .nullable()
    .notRequired()
    .matches(
      /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be|vimeo\.com)\/.+$/,
      'Please enter a valid YouTube or Vimeo URL',
    ),
  videoActive: yup.boolean().required('Video active status is required'),
});
export interface VideoFormValues {
  videoActive: boolean;
  videoURL: string;
  videoTitle: string;
}
